import { useNavigation } from "@react-navigation/native";
import React, { useContext, useEffect, useState } from "react";
import InfoPopupModal from "../../components/infoPopupModal";
import { Text, View } from "react-native";
import HeaderWithBack from "../../components/Header/headerWithBack";
import { useDispatch, useSelector } from "react-redux";
import { useCssStyle } from "../../customHook/getCssStyle";
import { useTranslation } from "react-i18next";
import { BLUETOOTH_DENIED, requestBluetoothPermission } from "../../js/requestPermissions/requestPermissions";
import { CHAMBER_KEY, DOOR_KEY, DOOR_KEY_GUIDE, DoorKeyContext, VALIDATION_OPTIONS } from "../../navigation/StackNavigator/doorKeyNavigator";
import { setGoHome, setShowLoginModal } from "../../Redux/Reducers/appConfigReducer";
import { openSettings, RESULTS } from "react-native-permissions";
import { setRenderFlashMessage } from "../../Redux/Actions/appConfigAction";
import { isWeb } from "../../utils/Helper";
import { DEMO_FLOW_ENABLED, DOOR_KEY_CATEGORY } from "../../config/Constant";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Loader from "../../components/Loader/loader";
import { sendAnalytics } from "../../Redux/Actions/analyticsAction";
import { getDigitalKeySupportedAuthMethods } from "../../Redux/Actions/doorKeyAction";

const DoorKey = () => {

    const { widgetSessionId, widgetLaunchTime } = useContext(DoorKeyContext);
    
    const navigation = useNavigation();
    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const { t } = useTranslation();


    const { isLoggedIn } = useSelector(state => state.appConfigSlice);
    const { supportedMethods } = useSelector(state => state.doorKeySlice);

    const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice);
    let reservationNumber = currentGuestDetails?.reservationNumber
    let locationId = currentGuestDetails?.location



    const [permissionError, setPermissionError] = useState(null); // { status: string, message: string }


    const handleCustomBackPress = () => {
        dispatch(setGoHome(true));
    };

    const handleContinue = () => {

        if(permissionError.status == BLUETOOTH_DENIED){
            openSettings().catch(() => {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: "Unable to open settings" }))
            });
        }
    }


    const initializeDoorKey = async () => {
        
        const doorkeyValidation = await AsyncStorage.getItem('doorkeyValidation');
        dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "DOOR KEY FLOW - INIT", { "element": "widget", "widgetSessionId": widgetSessionId, isVerified: doorkeyValidation }));

        if(doorkeyValidation){

            const allGranted = await handlePermissions();
            if (!allGranted) return;

            navigation.replace(CHAMBER_KEY);
        }
        else {

            let status, message;

            if (supportedMethods) {
                status = true; message = null;
                dispatch(getDigitalKeySupportedAuthMethods(reservationNumber, locationId))
            } else {
                const result = await dispatch(getDigitalKeySupportedAuthMethods(reservationNumber, locationId));
                status = result.status;
                message = result.message;
            }

            if(status){
                dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "REQUEST SUPPORTED METHODS - SUCCESS", { "element": "widget", "widgetSessionId": widgetSessionId }));
                const doorKeyGuide = await AsyncStorage.getItem('doorKeyGuide');

                if (!doorKeyGuide) {
                    navigation.replace(DOOR_KEY_GUIDE);
                    return;
                }

                const allGranted = await handlePermissions();
                if (!allGranted) return;
                if(!supportedMethods?.length){
                    navigation.replace(CHAMBER_KEY)
                    return
                }
                navigation.replace(VALIDATION_OPTIONS);
            } else {
                dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "REQUEST SUPPORTED METHODS - FAILED", { "element": "widget", "widgetSessionId": widgetSessionId, errorMessage: message || "Something went wrong" }));
                dispatch(setRenderFlashMessage(true, { type: "danger", message: message || "Something went wrong" }))
                dispatch(setGoHome(true));
            }
        }
    };


    const handleBluetoothPermission = async () => {
        const bluetoothPermissionStatus = await requestBluetoothPermission();

        if (bluetoothPermissionStatus == RESULTS.GRANTED) {
            return true;
        } else if (bluetoothPermissionStatus == RESULTS.UNAVAILABLE){
            dispatch(setRenderFlashMessage(true, { type: "info", message: "Please enable blutooth to use this feature." }))
            dispatch(setGoHome(true));
        } else {
            setPermissionError({
                status: BLUETOOTH_DENIED,
                message: "Please provide Bluetooth permission to use this feature."
            });
        }

        return false;
    };

    const handlePermissions = async () => {

        const isBluetoothSupported = await handleBluetoothPermission();
        if (!isBluetoothSupported) return false;

        return true;
    };

    useEffect(() => {
        initializeDoorKey();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <View style={getStyles(['widgetRootContainer', 'doorkeyRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleCustomBackPress} />

            {permissionError?.status ?
                <InfoPopupModal
                    subtitle={permissionError.message}
                    primaryBtnLabel={"Go to setting"}
                    onContinue={permissionError.status == BLUETOOTH_DENIED ? handleContinue : null}
                    onClose={handleCustomBackPress}
                    secondaryBtnLabel={"Okay"}
                    OnRequestClose={handleCustomBackPress}
                />
                : 
                <View style={{ height: "100%", justifyContent: "center", alignItems: "center" }}>
                    <Loader style={getStyles(['crossOverContaniner_loader'])} />
                </View>
            }
        </View>
    );
};


export default DoorKey;
